import { render, staticRenderFns } from "./OnboardingCommercial.vue?vue&type=template&id=4df19f2d&"
import script from "./OnboardingCommercial.vue?vue&type=script&lang=js&"
export * from "./OnboardingCommercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports